import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { NativeProps, withNativeProps } from '../utils/native-props'
import styles from './dialog.module.scss';

export const tuple = <T extends string[]>(...args: T) => args;
const ButtonTypes = tuple('default', 'primary', 'glod');
export type ButtonType = typeof ButtonTypes[number];

const ButtonWidthTypes = tuple('full', 'half');
export type ButtonWidthTypes = typeof ButtonWidthTypes[number];
export type Action = {
  key: string | number
  text: string
  disabled?: boolean
  type?: ButtonType;
  width?: ButtonWidthTypes;
  onClick?: () => void | Promise<void>
} & NativeProps

export const DialogActionButton: FC<{
  action: Action,
  onAction: () => void | Promise<void>
}> = props => {
  const { action } = props

  const [loading, setLoading] = useState(false)

  return withNativeProps(
    props.action,
    <div
      key={action.key}
      onClick={async () => {
        setLoading(true)
        try {
          await action.onClick?.()
          await props.onAction?.()
        } catch (e) {
          setLoading(false)
          throw e
        }
        setLoading(false)
      }}
      className={classNames(styles.dialog_btn, {
        [styles.dialog_btn_primary]: action.type === 'primary',
        [styles.dialog_btn_glod]: action.type === 'glod',
        [styles.dialog_btn_half]: action.width === 'half',
        [styles.dialog_btn_full]: action.width === 'full',
      })}
    >
      {action.text}
    </div>
  )
}
